import React from "react";
import mobile1 from "../../img/mobile1.png";
import mobile2a from "../../img/mobile2a.png";
import mobile2b from "../../img/mobile2b.png";
import mobile3 from "../../img/mobile3.png";

function MobileProjects() {
  return (
    <div>
      <div className="bg-primary-dark py-20">
        <h1 className="section-title text-white">Mobile Projects</h1>

        <div className="max-w-screen-xl mx-auto pt-20 pb-20 text-white flex flex-col lg:flex-row gap-5">
          <div className="relative px-20 grid place-items-center">
            <img
              src={mobile1}
              className="h-96 mx-auto z-10 object-contain"
              alt=""
            />
            <img
              src={mobile1}
              className="h-96 mx-auto absolute opacity-5 top-0 left-0 scale-150 object-contain"
              alt=""
            />
          </div>
          <div className="font-secondary flex-1 px-6 lg:px-20">
            <h2 className="text-2xl bg-white text-primary-dark font-semibold px-6 py-1 rounded-sm w-fit mb-4">
              VIP Pharmacy
            </h2>
            <p className="text-justify">
              is a React Native and Firebase-based e-commerce smartphone
              platform. Customers can use this app to place orders for
              medications, process, and checkout. Customers can simply send in a
              photo of their receipt, and the admin will place the order for
              them. The customer can choose whether the medicine is for
              maintenance or not, and if it is, it will be saved for the next
              purchase. Customers can also request/call for assistance in order
              for the admin to assist them on their needs. The administrator has
              control over products, transactions, stores, and consumers.
            </p>
            <div className="flex my-3 gap-x-2 flex-wrap gap-y-2">
              <p className="mobile-chip">React Native</p>
              <p className="mobile-chip">React Context API</p>
              <p className="mobile-chip">React Native Elements</p>
              <p className="mobile-chip">React Navigation</p>
              <p className="mobile-chip">Expo</p>
              <p className="mobile-chip">Firebase</p>
            </div>
          </div>
        </div>

        <div className="max-w-screen-xl mx-auto pt-20 pb-10 text-white flex flex-col lg:flex-row gap-5">
          <div className="font-secondary flex-1 order-2 px-6 lg:px-20 lg:order-1">
            <h2 className="text-2xl bg-white text-primary-dark font-semibold px-6 py-1 rounded-sm w-fit mb-4">
              Fuzz & Blockz
            </h2>
            <p className="text-justify">
              is a hyper-casual endless dodge mobile game created in Unity using
              C#. Play as the brave White Fuzz and take on a variety of daunting
              challenges of varying degrees of difficulty. Tap the screen to
              avoid and gather energy balls as you navigate across various
              terrains. On each stage, there are a variety of lowpoly design
              maps to enjoy.
            </p>
            <div className="flex my-3 gap-x-2 flex-wrap gap-y-2">
              <p className="mobile-chip">Unity</p>
              <p className="mobile-chip">Google Play Leaderboards</p>
              <p className="mobile-chip">Adobe Photoshop</p>
              <p className="mobile-chip">Adobe AI</p>
            </div>
          </div>
          <div className="px-20 flex order-1 lg:order-2">
            <img
              src={mobile2a}
              className="h-96 mx-auto object-contain"
              alt=""
            />
            <img
              src={mobile2b}
              className="h-96 mx-auto object-contain hidden lg:block"
              alt=""
            />
          </div>
        </div>

        <div className="max-w-screen-xl mx-auto pt-20 pb-20 text-white flex flex-col lg:flex-row gap-5">
          <div className="relative px-20 grid place-items-center">
            <img
              src={mobile3}
              className="h-96 mx-auto z-10 object-contain"
              alt=""
            />
            <img
              src={mobile3}
              className="h-96 mx-auto absolute opacity-5 top-0 right-0 scale-110 object-contain"
              alt=""
            />
          </div>
          <div className="font-secondary flex-1 px-6 lg:px-20">
            <h2 className="text-2xl bg-white text-primary-dark font-semibold px-6 py-1 rounded-sm w-fit mb-4">
              Nutr.io
            </h2>
            <p className="text-justify">
              is a mobile application developed using React Native and Firebase.
              This system is designed to make it simple and quick for pregnant
              women to connect with RNDs (Registered Nutritionist Dietitians).
              Authentication (registration and login), Dietitian selection, and
              day-to-day communication with the appointed Dietitian via online
              messaging are just a few of the features. The real-time update
              functionality of Firebase Firestore makes updating patient data a
              breeze. React Context API is used to distribute data to the
              frontend, React Native Elements is used to design the user
              experience, and React Navigation is used to handle page routing.
            </p>
            <div className="flex my-3 gap-x-2 flex-wrap gap-y-2">
              <p className="mobile-chip">React Native</p>
              <p className="mobile-chip">React Context API</p>
              <p className="mobile-chip">React Native Elements</p>
              <p className="mobile-chip">React Navigation</p>
              <p className="mobile-chip">Expo</p>
              <p className="mobile-chip">Firebase</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MobileProjects;
